export const POPUP_HEIGHT: number = 260
export const DEFAULT_OPTION_HEIGHT: number = 32
export const DEFAULT_OPTION_WIDTH: number = 32
